export enum ImageRepeat {
  noRepeat,
  repeat,
  repeatX,
  repeatY,
}
